import React, { useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SubComponentContainer, Label } from '#component/general/list-filter/components/general/styles';

export const RadioButtonsGroup = ({
  name,
  label,
  relatedTo,
  options,
  onChange
}) => {
  const selected = useSelector(s => s.listFilter?.[relatedTo]?.[name]?.value, shallowEqual) ?? {};
  const defaultValue = options.find(o => o.data.default)?.data?.value ?? options?.[0]?.data?.value;
  const val = selected?.[0]?.data?.value || defaultValue;
  const [value, setValue] = useState(val);

  const handleChange = (e, newValue) => {
    setValue(newValue);
    onChange(options.filter(o => o.data.value === newValue));
  };

  return (
    <SubComponentContainer>
      <Label>{label}</Label>
      <RadioGroup
        row
        name={name}
        value={value}
        onChange={handleChange}
        id={`filter-radio-button-group-${label}`}
      >
        {options.map(option => {
          const { label: l, data: d } = option;
          const v = d.value;
          return <FormControlLabel key={`${l}_${v}`} value={v} control={<Radio />} label={l} />;
        })}
      </RadioGroup>
    </SubComponentContainer>
  );
};
